import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { ApiService } from '@shared/services/api.service';
import { OverlayService } from '@shared/services/overlay.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, AsyncPipe],
  selector: 'aux-ag-cis-log-actions',
  styles: [],
  template: `
    @if ((hideDownloadLink$ | async) === false) {
      <button
        class="aux-link flex items-center space-x-2 focus:outline-none"
        (click)="onDownload()"
      >
        <aux-icon name="FileDownload" />
        <span>Download</span>
      </button>
    }
  `,
})
export class AgCisLogActionsComponent implements ICellRendererAngularComp {
  private apiService = inject(ApiService);
  private overlayService = inject(OverlayService);

  hideDownloadLink$ = new BehaviorSubject(true);

  private value = '';

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async agInit(params: ICellRendererParams) {
    this.value = params.value;
    await this.checkDownloadItem(params.value);
  }

  async checkDownloadItem(value: string) {
    const newValue = `${value}trials`;

    if (value) {
      const { data, success } = await this.apiService.getS3ZipFile(newValue);

      if (success && data) {
        this.hideDownloadLink$.next(false);
      }
    }
  }

  async onDownload() {
    if (this.value) {
      const newValue = `${this.value}trials`;
      const element = newValue.split('/').reverse().shift();
      const cnf_no = element?.substring(0, element.length - 6) || '';
      const { data, success } = await this.apiService.getS3ZipFile(newValue);

      if (success && data) {
        const fileName = `CNF ${cnf_no}`;

        await this.apiService.downloadZipOrFile(data, fileName);
      } else {
        this.overlayService.error('No uploaded file!');
      }
    }
  }

  refresh(): boolean {
    return false;
  }
}
